import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  employeeLevel: {}
};

const employeeLevelSlice = createSlice({
  name: 'employeeLevel',
  initialState,
  reducers: {
    setEmployeeLevel: (state, action) => {
      state.employeeLevel = action.payload;
    }
  }
});

const { setEmployeeLevel } = employeeLevelSlice.actions;

export const employeeLevelSelector = (state) => state.employeeLevel;
const employeeLevelReducer = employeeLevelSlice.reducer;

export default employeeLevelReducer;

export const getSingleEmployeeLevel = (data) => (dispatch) => {
  dispatch(setEmployeeLevel(data));
};
